import { render, staticRenderFns } from "./App2.vue?vue&type=template&id=5908eb27&"
import script from "./App2.vue?vue&type=script&lang=js&"
export * from "./App2.vue?vue&type=script&lang=js&"
import style0 from "./App2.vue?vue&type=style&index=0&id=5908eb27&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports